import { ButtonMenu } from "designSystem/index";
import React, { useState } from "react";
import CssColumnGrid from "designSystemLegacy/CssColumnGrid";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { ColorPicker } from "designSystem/index";

export default () => {
	const [backgroundColor, setBackgroundColor] = useState("#29F");
	
	const onColorChange = (color: string) => {
		setBackgroundColor(color);
	};

	return (
		<CssColumnGrid columns={1}>
			<ButtonMenu
				endIcon={(
					<ArrowDropDownIcon
						sx={{
							height: 16,
							width: 16,
						}}
					/>
				)}
				label="Pick a color"
				sx={{
					backgroundColor,
					display: "flex",
					margin: "auto",
					padding: 1,
					position: "relative",
					zIndex: 1,
				}}
			>
				<ColorPicker
					color={backgroundColor}
					onColorChange={onColorChange}
				/>
			</ButtonMenu>
		</CssColumnGrid>
	);
};
